import * as api from "@/api/williams/contractors";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useContractorAssociations(id: string) {
  return useQuery({
    queryKey: queryKeys.contractor.associations(id),
    queryFn: () => api.getContractorAssociations(id),
  });
}
